import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './plugins/ant-design-vue.js'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// import './static/js/mock'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
